import { render, staticRenderFns } from "./TiendaPublica.vue?vue&type=template&id=bd9609b4&scoped=true"
import script from "./TiendaPublica.vue?vue&type=script&lang=js"
export * from "./TiendaPublica.vue?vue&type=script&lang=js"
import style0 from "./TiendaPublica.vue?vue&type=style&index=0&id=bd9609b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9609b4",
  null
  
)

export default component.exports